import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const AutomationPage: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect para workflows por padrão
    navigate('/automation/workflows', { replace: true });
  }, [navigate]);

  return null;
};
